import { render, staticRenderFns } from "./Template20.vue?vue&type=template&id=0d24f505&scoped=true&"
import script from "./Template20.vue?vue&type=script&lang=js&"
export * from "./Template20.vue?vue&type=script&lang=js&"
import style0 from "./Template20.vue?vue&type=style&index=0&id=0d24f505&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d24f505",
  null
  
)

export default component.exports